import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'

import Layout from '../../../layouts'
import LargeHero from "../../../components/elements/largeHero"
import { SizedText, Canon, Body } from "../../../components/elements/typography"
import Grid from '../../../components/elements/grid'
import ReviewSection from '../../../components/sections/reviewSection'
import SEO from '../../../components/elements/seo'
import PhExternalLink from '../../../components/elements/externalLink'



const BsuinessDigitalBankingIndexPage = () => {
  return (
    <Layout isSubMenuOpen={true} openAccountLink={true}>

      <SEO
        title="TCB Digital Banking"
        description="Check your balance, manage your card, send money all with a few taps. Banking has never been so easy — finally, a digital banking app for the modern age."
        location="/business/digital-banking"
        ogImg='/images/social-graph/the-claxton-bank.jpg'
      />

      { /* --- HERO SECTION ----*/ }
      <LargeHero.Container
        background={{ 
          //https://www.svgbackgrounds.com/
          backgroundColor: `#00D2FF`,
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25'%3E%3Cdefs%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='0' x2='0' y1='0' y2='100%25' gradientTransform='rotate(240)'%3E%3Cstop offset='0' stop-color='%2395DAF7'/%3E%3Cstop offset='1' stop-color='%234ECBFF'/%3E%3C/linearGradient%3E%3Cpattern patternUnits='userSpaceOnUse' id='b' width='540' height='450' x='0' y='0' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.02'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect x='0' y='0' fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect x='0' y='0' fill='url(%23b)' width='100%25' height='100%25'/%3E%3C/svg%3E")`,
          backgroundAttachment: `fixed`,
          backgroundSize: `cover`,
        }}
        breadcrumbLinks={[
          { path: "/", text: "Home" },
          { path: "/personal/", text: "Personal Banking" },
          { path: "/personal/digital-banking", text: "Digital Banking" }
        ]}
        styles={{
          paddingBottom: `0`,
          '@media (min-width: 680px)': {
            paddingBottom: `4rem`,
            '.heroContent': { width: `calc(60% - 1rem)`},
            '.heroImage': { width: `calc(40% - 1rem)`},
          },
          '@media (min-width: 1080px)': {
            '.heroContent': { width: `calc(55% - 2.5rem) !important`},
            '.heroImage': { width: `calc(45% - 2.5rem) !important`},
          }
      }}>
        <LargeHero.Content>
          <LargeHero.Eyebrow text="Digital Banking" />
          <h1 css={{fontFamily: `Proxima-nova`, textTransform: `uppercase`, 'span': {display: `block`, lineHeight: `1.25`, padding: `0.25rem 0`, hyphens: `auto`}}}>
            <SizedText as="span" smallSize="2.281" largeSize="4.624">Digital Banking Done Right!</SizedText>
          </h1>
          <p css={{fontSize: `1.125rem`, maxWidth: `850px`, padding: `1.25rem 0`, lineHeight: `1.75`, textAlign:`justify`, hyphens: `auto` }}>
          There is so much that you can do with the iBankTCB digital banking app, all without ever leaving your home. Check your balance, manage your card, send money all with a few taps. Banking has never been so easy — finally, a digital banking app for the modern age.
          </p>
          <div css={{marginTop: `2rem`}}>
                          <PhExternalLink to="https://apps.apple.com/us/app/the-claxton-bank-mobile/id994317983?ign-mpt=uo%3D4">
                <StaticImage src="../images/products/digital-banking/app-store-badge.png" alt="Download on the App Store" height="50" width="168" />
              </PhExternalLink>
              <PhExternalLink to="https://play.google.com/store/apps/details?id=com.csiweb.digitalbanking.bk0704"><StaticImage src="../images/products/digital-banking/google-play-badge.png" alt="Get it on Google Play" height="50" width="168"/></PhExternalLink><br />
          </div>
        </LargeHero.Content>
        <LargeHero.Image>
        <StaticImage 
          css={{
            display: `block !important`, 
            marginTop: `3rem`, 
            '@media (min-width: 736px)': { display: 'none !important' } 
          }} 
          src="../../../images/products/digital-banking/digital-banking-ipad_mobile.png" 
          alt="TCB Digital Banking and Mobile Deposit Screenshots"
        />
        <StaticImage 
          css={{
            display: `none !important`,  
            '@media (min-width: 736px)': { display: 'block !important' }, 
            '@media (min-width: 1024px)': { display: 'none !important' } 
          }} 
          src="../../../images/products/digital-banking/digital-banking-ipad_tablet.png" 
          alt="TCB Digital Banking and Mobile Deposit Screenshots"
        />
        <StaticImage 
          css={{
            display: `none !important`,  
            '@media (min-width: 1024px)': { display: 'block !important' } 
          }} 
          src="../../../images/products/digital-banking/tcb-digital-banking-02_full.png" 
          alt="TCB Digital Banking and Mobile Deposit Screenshots"
        />
        </LargeHero.Image>
      </LargeHero.Container>

      {/* --- Advanced Security --- */ }
      <Grid.FullWidthSection styles={{
        marginTop: `4rem`,
        overflow: `hidden`,
        '@media (min-width: 1024px)': {
          margin: `4rem 0`
        }
      }}>
        <Grid.Block start={[2, 2, 1, 1, 2, 3]} span={[12, 12, 4, 3,3, 3]} css={{
          padding: `0 3rem`,
          gridRow: `2`,
          '@media (min-width: 736px)': {
            gridRow: `1`,
            padding: `0 0 4rem 0`
          },
          '@media (min-width: 1024px)': {
            padding: `0 0rem 0 0rem`
          },
          '@media (min-width: 1224px)': {
            padding: `0 0rem 0 5rem`
          }
        }}>
          <StaticImage 
          css={{
            display: `block !important`, 
            marginTop: `3rem`, 
            '@media (min-width: 736px)': { display: 'none !important' } 
          }} 
            src="../../../images/products/digital-banking/digital-banking-security_mobile.png" 
            alt="TCB Digital Banking with Face ID" 
          />
          <StaticImage 
            css={{
              display: `none !important`,  
              '@media (min-width: 736px)': { display: 'block !important' }, 
              '@media (min-width: 1024px)': { display: 'none !important' } 
            }} 
            src="../../../images/products/digital-banking/digital-banking-security_tablet.png" 
            alt="TCB Digital Banking with Face ID" 
        />
          <StaticImage 
            css={{
              display: `none !important`,  
              '@media (min-width: 1024px)': { display: 'block !important' } 
            }} 
            src="../../../images/products/digital-banking/digital-banking-security.png" 
            alt="TCB Digital Banking with Face ID" 
          />
        </Grid.Block>
        <Grid.Block start={[2, 2, 6, 4, 6, 7]} span={[12, 12, 7, 10, 7, 6]} styles={{ alignSelf: `center`}}>
          <SizedText as="span" smallSize="1.424" largeSize="1.802">Advanced Security</SizedText>
          <Canon>Protecting your money and your data is our top priority.</Canon>
          <Body>
          Log in quickly and securely with fingerprint or facial recognition. Our app uses strong 128-bit AES encryption and multi-factor authentication combined with fraud anomaly detection systems to keep your money and your data safe and secure.
          </Body>
        </Grid.Block>
      </Grid.FullWidthSection>

      {/* --- Card Controls --- */ }
      <Grid.FullWidthSection styles={{ overflow: `hidden`,padding: `4rem 0`, backgroundColor: `#fff`, boxShadow: `1px 7px 21px -15px rgba(0,0,0,0.75), 1px -7px 21px -15px rgba(0,0,0,0.75)`,
        backgroundColor: `#FFFFFF`,
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='250' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.02'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/svg%3E")`,
         
    }}>
        <Grid.Block start={[2,2,3,2,3]} span={[12,12,6,8,6]} styles={{margin: `4rem 0`, alignSelf: `center`}}>
          <SizedText as="span" smallSize="1.424" largeSize="1.802">Debit Card Controls</SizedText>
          <Canon>Control your debit card right from the app.</Canon>
          <Body>
          Your debit card is in your control, with Card Controls in digital banking. Turn your card on and off instantly with the tap of a button, activate new cards, change your PIN, request temporary limit increases, 
          set travel alerts, and report your card lost or stolen. It’s never been easier to manage your card.
          </Body>
        </Grid.Block>
        <Grid.Block start={[2,2,9,10,9, 9]} span={[12,12,6,5,5, 4]} css={{ 
          gridRow: `-1`,
          '@media (min-width: 1224px)': {
            padding: `0 2rem 0 3rem`
          }
        }}>
          <StaticImage 
              css={{
                display: `block !important`,  
                '@media (min-width: 736px)': { display: 'none !important' },
                '@media (min-width: 1024px)': { display: 'block !important' } 
              }} 
              src="../../../images/products/digital-banking/tcb-debit-card-controls_full.png" 
              alt="TCB Debit Card and Digital Banking Card Controls" 
            />
            <StaticImage 
              css={{
                display: `none !important`,  
                '@media (min-width: 736px)': { display: 'block !important' }, 
                '@media (min-width: 1024px)': { display: 'none !important' },
                
              }} 
              src="../../../images/products/digital-banking/tcb-debit-card-controls_cropped.png" 
              alt="TCB Debit Card and Digital Banking Card Controls" 
            />
        </Grid.Block>
      </Grid.FullWidthSection>

       {/* --- Mobile Walets --- */ }
       <Grid.FullWidthSection styles={{marginTop: `4rem`}}>

       <Grid.Block start={[2, 2, 1, 1, 2, 3]} span={[12, 12,4, 3,4, 4]} css={{
          padding: `0 3rem`,
          gridRow: `2`,
          '@media (min-width: 736px)': {
            gridRow: `1`,
            padding: `0 0 4rem 0`
          },
          '@media (min-width: 1024px)': {
            padding: `0 0rem 0 0rem`
          },
          '@media (min-width: 1224px)': {
            padding: `0 4rem 0 4rem`
          }
        }}>
          <StaticImage 
          css={{
            display: `block !important`, 
            marginTop: `3rem`, 
            '@media (min-width: 736px)': { display: 'none !important' } 
          }} 
          src="../../../images/products/digital-banking/mobile-wallets_mobile.png"
            alt="Screenshot of the TCB Debit Card in ApplePay wallet" 
          />
          <StaticImage 
            css={{
              display: `none !important`,  
              '@media (min-width: 736px)': { display: 'block !important' }, 
              '@media (min-width: 1024px)': { display: 'none !important' } 
            }} 
            src="../../../images/products/digital-banking/mobile-wallets_tablet.png" 
            alt="Screenshot of the TCB Debit Card in ApplePay wallet" 
        />
        <StaticImage 
            css={{
              display: `none !important`,  
              '@media (min-width: 1024px)': { display: 'block !important', marginBottom: `4rem` },
              '@media (min-width: 1700px)': { display: 'none !important' } 
            }} 
            src="../../../images/products/digital-banking/mobile-wallets_tablet2.png" 
            alt="Screenshot of the TCB Debit Card in ApplePay wallet" 
        />
          <StaticImage 
            css={{
              display: `none !important`,  
              '@media (min-width: 1700px)': { display: 'block !important' } 
            }} 
            src="../../../images/products/digital-banking/mobile-wallets.png" 
            alt="Screenshot of the TCB Debit Card in ApplePay wallet" 
          />
        </Grid.Block>
        <Grid.Block start={[2,2,7,4,7]} span={[12,12,6, 10, 6]} styles={{ alignSelf: `center`}}>
          <SizedText as="span" smallSize="1.424" largeSize="1.802">Mobile Wallet Enabled</SizedText>
          <Canon>Forgot your wallet? No problem pay with your phone.</Canon>
          <Body css={{marginBottom: `3rem`}}>
          We support all the major mobile payment platforms including Apple Pay, Google Pay, and Samsung Pay, so you can enjoy the security and convenience of making payments with your mobile device. Adding your card to a 
          mobile wallet means that you can leave your actual wallet at home.
          </Body>
          <StaticImage 
            src="../../../images/products/digital-banking/mobile-wallet-logos.png" 
            alt="Logos of supported wallets: Apple Pay, Google Pay, Samsung Pay, Fitbit Pay, and Garmin Pay" 
          />
        </Grid.Block>
      </Grid.FullWidthSection>

        {/* --- SPIN Pay --- */ }
        <Grid.FullWidthSection styles={{
          overflow:`hidden`, 
          paddingTop: `4rem`, 
          backgroundColor: `#fff`, 
          boxShadow: `1px 7px 21px -15px rgba(0,0,0,0.75), 1px -7px 21px -15px rgba(0,0,0,0.75)`, 
          backgroundColor: `#FFFFFF`,
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='250' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.02'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/svg%3E")`,
          '@media (min-width: 1024px)': {
            padding: `4rem 0`,
          },
        }}>
        <Grid.Block start={[2, 2, 3, 2, 3]} span={[12,12,6,8,6]} styles={{
          alignSelf: `center`,
          margin: `0`,
          '@media (min-width: 1224px)': {
            margin: `4rem 0`, 
          }
        }}>
          <SizedText as="span" smallSize="1.424" largeSize="1.802">SPIN PAY</SizedText>
          <Canon>Pay anyone instantly via text message or email.</Canon>
          <Body>
          With SPIN Pay from TCB you can send money to anyone in the US instantly directly from our app for free.  All they need is a phone number or email address and a US based debit card.  Unlike other 
          P2P services, you don't need to maintain a seperate funding account, and the recipient doesn't need to download an app.  Transfers are made directly from your account to their account instantly.          
          </Body>
        </Grid.Block>
        <Grid.Block start={[2, 2, 10, 10, 9, 10]} span={[12, 12, 5,5, 4, 3]} css={{
          padding: `0 1rem`,
          gridRow: `2`,
          '@media (min-width: 736px)': {
            gridRow: `1`,
            padding: `0 0 4rem 0`
          },
          '@media (min-width: 1024px)': {
            padding: `0 0rem 0 0rem`
          },
          '@media (min-width: 1224px)': {
            padding: `0 0rem 0 0rem`
          }
        }}>
          <StaticImage 
          css={{
            display: `block !important`, 
            marginTop: `3rem`, 
            '@media (min-width: 736px)': { display: 'none !important' } 
          }} 
          src="../../../images/products/digital-banking/spinpay_mobile.png"  
            alt="Screenshot of TCB SPINPay Person-to-Person Payment" 
          />
          <StaticImage 
            css={{
              display: `none !important`,  
              '@media (min-width: 736px)': { display: 'block !important' }, 
              '@media (min-width: 1024px)': { display: 'none !important' } 
            }} 
            src="../../../images/products/digital-banking/spinpay_tablet.png"
            alt="Screenshot of TCB SPINPay Person-to-Person Payment" 
        />
          <StaticImage 
            css={{
              display: `none !important`,  
              '@media (min-width: 1024px)': { display: 'block !important', } 
            }} 
            src="../../../images/products/digital-banking/spinpay_full.png"
            alt="Screenshot of TCB SPINPay Person-to-Person Payment"  
          />
        </Grid.Block>
      </Grid.FullWidthSection>

      {/* --- Mobile Deposit --- */ }
      <Grid.FullWidthSection styles={{
        marginTop: `4rem`,
        '@media (min-width: 1024px)': {
          margin: `4rem 0`
        }
      }}>
        <Grid.Block start={[2, 2, 1, 1, 2, 3]} span={[12, 12, 4, 3,3, 3]} css={{
          padding: `0 3rem`,
          gridRow: `2`,
          '@media (min-width: 736px)': {
            gridRow: `1`,
            padding: `0 0 4rem 0`
          },
          '@media (min-width: 1024px)': {
            padding: `0 0rem 0 0rem`
          },
          '@media (min-width: 1224px)': {
            padding: `0 0rem 0 5rem`
          }
        }}>
          <StaticImage 
          css={{
            display: `block !important`, 
            marginTop: `3rem`, 
            '@media (min-width: 736px)': { display: 'none !important' } 
          }} 
          src="../../../images/products/digital-banking/mobileDeposit_mobile.png" 
            alt="Screenshot of TCB Multi-Check Mobile Deposit" 
          />
          <StaticImage 
            css={{
              display: `none !important`,  
              '@media (min-width: 736px)': { display: 'block !important' }, 
              '@media (min-width: 1024px)': { display: 'none !important' } 
            }} 
            src="../../../images/products/digital-banking/mobileDeposit_tablet.png" 
            alt="Screenshot of TCB Multi-Check Mobile Deposit" 
        />
          <StaticImage 
            css={{
              display: `none !important`,  
              '@media (min-width: 1024px)': { display: 'block !important' } 
            }} 
            src="../../../images/products/digital-banking/mobileDeposit.png" 
            alt="Screenshot of TCB Multi-Check Mobile Deposit" 
          />
        </Grid.Block>
        <Grid.Block start={[2, 2, 6, 4, 6, 7]} span={[12, 12, 7, 10, 7, 6]} styles={{ alignSelf: `center`}}>
          <SizedText as="span" smallSize="1.424" largeSize="1.802">Multi-Check Mobile Deposit</SizedText>
          <Canon>Deposit checks remotely, without a trip to the branch.</Canon>
          <Body>
          Deposit checks anywhere at any time. With multi-check mobile deposit, you can deposit up to 25 checks at a time in one transaction directly from your smartphone. It is as easy as entering the check amount and snapping a photo. Save time and get more done with the iBankTCB digital banking app.<sup>1</sup>
          </Body>
        </Grid.Block>
      </Grid.FullWidthSection>

      {/* --- Bill Pay --- */ }
      <Grid.FullWidthSection styles={{ 
          overflow: `hidden`,
          paddingTop: `4rem`, 
          backgroundColor: `#fff`, 
          boxShadow: `1px 7px 21px -15px rgba(0,0,0,0.75), 1px -7px 21px -15px rgba(0,0,0,0.75)`, 
          backgroundColor: `#FFFFFF`,
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='250' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.02'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/svg%3E")`,
          '@media (min-width: 1024px)': {
            padding: `4rem 0`,
          },
        }}>
        <Grid.Block start={[2, 2, 3,2,3]} span={[12,12,6, 9,6]} styles={{
          alignSelf: `center`,
          margin: `0`,
          '@media (min-width: 1224px)': {
            margin: `4rem 0`, 
          }
        }}>
          <SizedText as="span" smallSize="1.424" largeSize="1.802">Automatic Bill Pay</SizedText>
          <Canon>Never forget to pay a bill again, with TCB BillPay.</Canon>
          <Body>
          Manage your money like a pro and stay connected with all your accounts. Check balances, schedule transfers, make loan payments, automate bills, initiate stop pays, and more – all from your phone, all on the go.<sup>2</sup>
          </Body>
        </Grid.Block>
        <Grid.Block start={[2, 2, 11, 12, 10, 10]} span={[12, 12, 4,3,3, 3]} css={{
          padding: `0 3rem`,
          gridRow: `2`,
          '@media (min-width: 736px)': {
            gridRow: `1`,
            padding: `0 0 4rem 0`
          },
          '@media (min-width: 1024px)': {
            padding: `0 0rem 0 0rem`
          },
          '@media (min-width: 1224px)': {
            padding: `0 5rem 0 0rem`
          }
        }}>
          <StaticImage 
          css={{
            display: `block !important`, 
            marginTop: `3rem`, 
            '@media (min-width: 736px)': { display: 'none !important' } 
          }} 
          src="../../../images/products/digital-banking/bill-pay_mobile.png"  
          alt="Screenshot of TCB BillPay" 
          />
          <StaticImage 
            css={{
              display: `none !important`,  
              '@media (min-width: 736px)': { display: 'block !important' }, 
              '@media (min-width: 1024px)': { display: 'none !important' } 
            }} 
            src="../../../images/products/digital-banking/bill-pay_tablet.png" 
            alt="Screenshot of TCB BillPay" 
        />
          <StaticImage 
            css={{
              display: `none !important`,  
              '@media (min-width: 1024px)': { display: 'block !important' } 
            }} 
            src="../../../images/products/digital-banking/bill-pay_full.png"
            alt="Screenshot of TCB BillPay" 
          />
        </Grid.Block>
      </Grid.FullWidthSection>

         {/* --- Account Alerts --- */ }
         <Grid.FullWidthSection styles={{
           overflow: `hidden`,
        marginTop: `4rem`,
        '@media (min-width: 1024px)': {
          margin: `4rem 0`
        }
      }}>
        <Grid.Block start={[2, 2, 1, 1, 2, 3]} span={[12, 12, 4, 3,3, 3]} css={{
          padding: `0 3rem`,
          gridRow: `2`,
          '@media (min-width: 736px)': {
            gridRow: `1`,
            padding: `0 0 4rem 0`
          },
          '@media (min-width: 1024px)': {
            padding: `0 0rem 0 0rem`
          },
          '@media (min-width: 1224px)': {
            padding: `0 0rem 0 5rem`
          }
        }}>
          <StaticImage 
          css={{
            display: `block !important`, 
            marginTop: `3rem`, 
            '@media (min-width: 736px)': { display: 'none !important' } 
          }} 
          src="../../../images/products/digital-banking/alerts_mobile.png"  
            alt="Screenshot of TCB Digital Banking alerts" 
          />
          <StaticImage 
            css={{
              display: `none !important`,  
              '@media (min-width: 736px)': { display: 'block !important' }, 
              '@media (min-width: 1024px)': { display: 'none !important' } 
            }} 
            src="../../../images/products/digital-banking/alerts_tablet.png" 
            alt="Screenshot of TCB Digital Banking alerts" 
        />
          <StaticImage 
            css={{
              display: `none !important`,  
              '@media (min-width: 1024px)': { display: 'block !important' } 
            }} 
            src="../../../images/products/digital-banking/alerts.png" 
            alt="Screenshot of TCB Digital Banking alerts" 
          />
        </Grid.Block>
        <Grid.Block start={[2, 2, 6, 4, 6, 7]} span={[12, 12, 7, 10, 7, 6]} styles={{ alignSelf: `center`}}>
          <SizedText as="span" smallSize="1.424" largeSize="1.802">Account Alerts</SizedText>
          <Canon>Stay on top of your accounts with SMS and push notifications.</Canon>
          <Body>
          Stay in the know with custom alerts from the iBankTCB digital banking app. You can set up SMS or push alerts on your available balances, cleared checks, debits, NSF items, pending ACH items, online transfers, BillPay, and more.<sup>3</sup>
          </Body>
        </Grid.Block>
      </Grid.FullWidthSection>


      {/* --- Account Details --- */ }
      <Grid.FullWidthSection styles={{ 
          overflow: `hidden`,
          paddingTop: `4rem`, 
          backgroundColor: `#fff`, 
          boxShadow: `1px 7px 21px -15px rgba(0,0,0,0.75), 1px -7px 21px -15px rgba(0,0,0,0.75)`, 
          backgroundColor: `#FFFFFF`,
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='250' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.02'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/svg%3E")`,
          '@media (min-width: 1024px)': {
            padding: `4rem 0`,
          },
        }}>
        <Grid.Block start={[2, 2, 3,2,3]} span={[12,12,6, 9,6]} styles={{
          alignSelf: `center`,
          margin: `0`,
          '@media (min-width: 1224px)': {
            margin: `4rem 0`, 
          }
        }}>
          <SizedText as="span" smallSize="1.424" largeSize="1.802">Account Details</SizedText>
          <Canon>Manage your account and move money with just a few taps.</Canon>
          <Body>
          Manage your money like a pro and stay connected with all your accounts. Check balances, schedule transfers, make loan payments, automate bills, initiate stop pays, and more – all from your phone, all on the go.
          </Body>
        </Grid.Block>
        <Grid.Block start={[2, 2, 11, 12, 10, 10]} span={[12, 12, 4,3,3, 3]} css={{
          padding: `0 3rem`,
          gridRow: `2`,
          '@media (min-width: 736px)': {
            gridRow: `1`,
            padding: `0 0 4rem 0`
          },
          '@media (min-width: 1024px)': {
            padding: `0 0rem 0 0rem`
          },
          '@media (min-width: 1224px)': {
            padding: `0 5rem 0 0rem`
          }
        }}>
          <StaticImage 
          css={{
            display: `block !important`, 
            marginTop: `3rem`, 
            '@media (min-width: 736px)': { display: 'none !important' } 
          }} 
          src="../../../images/products/digital-banking/details_mobile.png"  
            alt="Screenshot of TCB Digital Banking" 
          />
          <StaticImage 
            css={{
              display: `none !important`,  
              '@media (min-width: 736px)': { display: 'block !important' }, 
              '@media (min-width: 1024px)': { display: 'none !important' } 
            }} 
            src="../../../images/products/digital-banking/details_tablet.png" 
            alt="Screenshot of TCB Digital Banking" 
        />
          <StaticImage 
            css={{
              display: `none !important`,  
              '@media (min-width: 1024px)': { display: 'block !important' } 
            }} 
            src="../../../images/products/digital-banking/details.png"
            alt="Screenshot of TCB Digital Banking" 
          />
        </Grid.Block>
      </Grid.FullWidthSection>

      <ReviewSection />

    </Layout>
  )
}

export default BsuinessDigitalBankingIndexPage
